export const VisionTitle = {
  en: "Vision",
  id: "Visi",
  ch: "愿景",
};

export const MissionTitle = {
  en: "Mission",
  id: "Misi",
  ch: "使命",
};

export const ValueTitle = {
  en: "Values",
  id: "Nilai",
  ch: "价值",
};
